import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export const Faqs = () => {
  return (
    <section id="faqs" className="bg-muted/60" data-testid="faqs-section">
      <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <div className="text-center">
          <p className="eyebrow-label" data-testid="faqs-eyebrow">Good questions. Clear answers.</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="faqs-heading">
            Before you begin.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faqs-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              className="rounded-2xl border border-border bg-white px-6 shadow-sm"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="py-5 text-left font-heading text-base font-bold text-slate-900 hover:no-underline sm:text-lg" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-muted-foreground sm:text-base" data-testid={`faq-content-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
